import { VALID_YYYY_MM_DD_DATE_REGEX } from '@/constants';
import { format } from 'date-fns/format';

export function isDate(date: string) {
  return !isNaN(new Date(date).getDate());
}

export function isValidYearMonthDayDateString(date: string) {
  return VALID_YYYY_MM_DD_DATE_REGEX.test(date) && isDate(date);
}

export function isValidDate(date: string) {
  return date.length === 10 && isValidYearMonthDayDateString(date);
}

export function parseYearMonthDayDateString(input: string) {
  // Date-only strings (e.g. "1970-01-01") are treated as UTC, not local time
  // when using new Date()
  // We need to split year, month, day to pass into new Date() separately
  // to get a localized Date
  const [year, month, day] = input.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
}

export function formatDateToYearMonthDayDateString(date: Date) {
  const year = String(date.getFullYear());
  let month = String(date.getMonth() + 1);
  let day = String(date.getDate());
  if (month.length < 2) {
    month = String(month).padStart(2, '0');
  }
  if (day.length < 2) {
    day = String(day).padStart(2, '0');
  }
  return [year, month, day].join('-');
}

export function formatDate(date: Date) {
  return formatDateToYearMonthDayDateString(date);
}

export function formatDateToString(date: Date) {
  return date.toISOString().split('T')[0];
}

export function nodeContainsDescendant(rootNode: Node, descendant: Node) {
  if (rootNode === descendant) {
    return true;
  }
  let parent = descendant.parentNode;
  while (parent != null) {
    if (parent === rootNode) {
      return true;
    }
    parent = parent.parentNode;
  }
  return false;
}

export function monthDiff(referenceDate: { month: number; year: number }, newDate: { month: number; year: number }): number {
  return newDate.month - referenceDate.month + 12 * (referenceDate.year - newDate.year);
}

export const formatDateRangeText = (since: Date | string, util: Date | string) => {
  if (!since || !util) {
    return '';
  }
  if (typeof since === 'string' && typeof util === 'string') {
    return `${since} - ${util}`;
  }
  if (since instanceof Date && util instanceof Date) {
    return `${format(since, 'YYYY-MM-DD')} - ${format(util, 'YYYY-MM-DD')}`;
  }
  return '';
};

export const isDateInRange = (inputDate: Date, range: { start: string; end: string }): boolean => {
  const date = new Date(inputDate);
  const startDate = new Date(range.start);
  const endDate = new Date(range.end);

  date.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  return date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime();
};
